import { View } from './view';

export const Mixologists = () => <View />;
